import {useCallback} from 'react';

import {
  RunPageHeaderQuery,
  useUpsertRunMutation,
} from '../../generated/graphql';
import * as GQLTypes from '../../types/graphql';
import {propagateErrorsContext} from '../../util/errors';

export const useUpdateRun = (
  run:
    | GQLTypes.RunPageRunQuery
    | NonNullable<RunPageHeaderQuery['project']>['run']
) => {
  const [updateRun] = useUpsertRunMutation({
    context: propagateErrorsContext(),
  });

  /**
   * A wrapper around `updateRun` (a PUT operation) that allows
   * the caller to specify only the fields to change (i.e.
   * a PATCH operation)
   */
  const patchRun = useCallback(
    async fields => {
      if (!run) {
        return {success: false};
      }
      try {
        await updateRun({
          variables: {
            id: run.id,
            tags: run.tags.map(t => t.name),
            displayName: run.displayName,
            notes: run.notes,
            ...fields,
          },
        });
        return {success: true};
      } catch (error: any) {
        const message =
          error?.networkError?.result?.errors?.[0]?.message ??
          error?.graphQLErrors?.[0]?.message ??
          'Failed to update run';
        return {success: false, error: message};
      }
    },
    [run, updateRun]
  );

  return patchRun;
};
